import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private _saveCmpUrl = `${environment.api}/Company/companyStore`;
  private _getCmpListUrl = `${environment.api}/Company/getComapanyList`;
  private _deleteCmpUrl = `${environment.api}/Company/cmpDelete`;
  private _getCmpByIdUrl = `${environment.api}/Company/getCompanyById`;
  private _updateCmpUrl = `${environment.api}/Company/companyUpdate`;
  private _statusCmpUrl = `${environment.api}/Company/cmpActiveById`;
  private _getCompanyUserByUrl = `${environment.api}/Company/getCompanyUserById`;
  
  private _addAccountUrl = `${environment.api}/Company/addAccount`;
  private _deleteAccountUrl = `${environment.api}/Company/deleteAccount`;
  
  constructor(private http: HttpClient) { }
  storeCmp(data)
  {
     return this.http.post<any>(this._saveCmpUrl,data);
  }
 
  getCompanyUserById(data)
  {
     return this.http.post<any>(this._getCompanyUserByUrl,data);
  }
 



  getCompanyList(data)
  {
     return this.http.post<any>(this._getCmpListUrl,data);
  }

  deleteCompany(data)
  {
     return this.http.post<any>(this._deleteCmpUrl,data);
  }
  getCompanyById(data)
  {
     return this.http.post<any>(this._getCmpByIdUrl,data);
  }
  updateCmp(data)
  {
     return this.http.post<any>(this._updateCmpUrl,data);
  }


  activeCmp(data)
  {
     return this.http.post<any>(this._statusCmpUrl,data);
  }

  addAccount(data)
  {
     return this.http.post<any>(this._addAccountUrl,data);
  }
  deleteAccount(data)
  {
     return this.http.post<any>(this._deleteAccountUrl,data);
  }

}
